import { Component, Injector, Input } from '@angular/core';
import { Stylable } from '../base-types';

export interface IconSettings extends Stylable{
  size?: string,
  hoverSettings?: Stylable,
  selectedSettings?: Stylable
}

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {

  @Input() id: string;
  @Input() tooltip: string;

  @Input() set settings(_settings: IconSettings){
    this._initSettings(_settings)
  }
  get settings(){
    return this._settings;
  }
  _settings: IconSettings

  /**
   * @deprecated
   */
  @Input() size: number = 40;
  /**
   * @deprecated
   */
  @Input() border: 'none'|'square'|'circle' = 'none'
  /**
   * @deprecated
   */
  @Input() clickable: boolean = false
  /**
   * @deprecated
   */
  @Input() selected: boolean = false

  hover:boolean

  constructor(protected _injector: Injector) {
    this._initSettings();
  }

  private _initSettings(settings?: IconSettings){
    const _settings = JSON.parse(JSON.stringify(settings||{}))

    _settings.size = _settings.size || '24px';
    _settings.width = _settings.width || _settings.size;
    _settings.height = _settings.height || _settings.size;
    _settings.border = _settings.border || 'none';
    _settings.fontColor = _settings.fontColor || 'inherit';

    _settings.hoverSettings = _settings.hoverSettings || JSON.parse(JSON.stringify(_settings))
    _settings.selectedSettings = _settings.selectedSettings || JSON.parse(JSON.stringify(_settings))
    
    this._settings = _settings
  }
}
